import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function AppHeader() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-violet-900/30 bg-slate-950/80 backdrop-blur-md">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AppLogo size={32} />
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg text-white tracking-tight">
              Trader<span className="text-violet-400">Mind</span>
            </span>
            <span className="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full bg-violet-500/15 border border-violet-500/25 text-violet-300 text-xs font-medium">
              Step 1 · I Ching
            </span>
          </div>
        </div>
        <nav className="flex items-center gap-6">
          <a
            href="/compatibility-reader"
            className="text-violet-300 text-sm font-medium border-b-2 border-violet-500 pb-0.5"
          >
            Bias Diagnosis
          </a>
        </nav>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center text-white text-xs font-bold">
            ☯
          </div>
        </div>
      </div>
    </header>
  );
}